import React, {useEffect, useState, useRef} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";

const DeleteLandButton = styled(motion.button)`    
    width: 25%;    
    height: 30px;
    padding: 4px 12px;
    margin: 3px;
    display: flex;
    justify-content: center;
    align-items: center;

    
    border: 1px solid #FAAD16;
    box-sizing: border-box;
    border-radius: 41px;
    background: transparent;
    color: #FAAD16;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 180%;
    
    cursor: pointer;
`


const LoadingOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;

    background: rgba(0, 0, 0, 0);
    text-align: center;
    z-index: 999;
`

const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;

`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;

    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: auto;
    height: 24px;
    float: right;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const ContentText = styled.div`
    font-size: 18px;
    line-height:24px;
    font-weight: bold;
`

const NoteText = styled.div`
    font-size: 16px;
    line-height:24px;
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const FlexActionColumn = styled.a`
    min-width: 125px;
    width: 20%;
    
    cursor: pointer;
`

const DeleteLandConfirmationModal = (props) => {
    const [modal, setModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const toggle = () => {
        setLoading(false);
        setModal(!modal);
    };

    return (
        <AnimatePresence>
            <DeleteLandButton
                key={"updateAppraiseButton"}
                onClick={toggle}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}>
                DELETE</DeleteLandButton>
            {
                modal && (
                    <Popup
                        initial={"initial"}
                        animate={"isOpen"}
                        exit={"exit"}
                        variants={modalVariant}>
                        <PopupInner variants={containerVariant}>
                            <PopupHeader>
                                {props.header}
                                <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                            </PopupHeader>
                            { loading ? (
                                <Spinner/>): (
                            <ContentArea>
                                <ContentText>{props.message}</ContentText>
                                <br/>
                                <NoteText>{props.note}</NoteText>
                            </ContentArea>
                            )}
                            <PopupFooter>
                                <PopupButton onClick={toggle}>Cancel</PopupButton>
                                <PopupButton onClick={() => {
                                        setLoading(true);
                                        props.action(props.landID)
                                            .catch(()=>{
                                                setLoading(false);
                                            })
                                    }
                                } primary>{props.actionLabel}</PopupButton>
                            </PopupFooter>
                        </PopupInner>
                </Popup>
                )
            }
        </AnimatePresence>
            );
}

export default DeleteLandConfirmationModal;
